import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';


//获得自产/代加工
export async function isSettleAccounts(params) {
    return post(erpserver+'/pickingList/isSettleAccounts', params, true)
}
//获得自产/代加工
export async function getScorderList(params) {
    return post(erpserver+'/scorder/getScorderList', params, true)
}


